const sortByQueryTerm = (a, b, sanitizedQuery) => {
    // if user is searching, items that START with the userInput should appear on top
    const aStartsWithUserInput = a._tokenizedLabel.startsWith(sanitizedQuery);
    const bStartsWithUserInput = b._tokenizedLabel.startsWith(sanitizedQuery);

    if (aStartsWithUserInput && !bStartsWithUserInput) {
        return -1;
    } else if (bStartsWithUserInput && !aStartsWithUserInput) {
        return 1;
    }

    return 0;
};

export { sortByQueryTerm };
